import { ROUTES } from "@/constants/routes";
import { TOUR_STORAGE_PREFIX } from "@/features/tours/constants";

export function clearSessionAndRedirect() {
  const selectedLanguage = "i18nextLng";
  const languageValue = localStorage.getItem(selectedLanguage);
  const tourEntries = Array.from({ length: localStorage.length }, (_, index) => localStorage.key(index))
    .filter((key): key is string => key !== null && key.startsWith(TOUR_STORAGE_PREFIX))
    .map((key) => [key, localStorage.getItem(key)] as const);
  
  // Clear everything
  localStorage.clear();
  
  // Restore language preference
  if (languageValue) {
    localStorage.setItem(selectedLanguage, languageValue);
  }
  tourEntries.forEach(([key, value]) => {
    if (value !== null) localStorage.setItem(key, value);
  });
  
  // Full page reload to login
  window.location.href = ROUTES.login;
}

export const getFullNameAndAvatarText = () => {
  const firstname = localStorage.getItem("firstname") || "";
  const lastname = localStorage.getItem("lastname") || "";
  const infix = localStorage.getItem("infix") || "";
  const email = localStorage.getItem("email") || "";

  const fullName = firstname || lastname || infix
    ? `${firstname} ${infix ? infix + " " : ""}${lastname}`.trim()
    : email || "Username";

  const avatarText = firstname || lastname
    ? `${firstname.charAt(0) || ""}${lastname.charAt(0) || ""}`.toUpperCase()
    : `${email.charAt(0) || ""}${email.charAt(1) || ""}`.toUpperCase();

  return { fullName, avatarText };
};
